import React from 'react';
import zubaleMark from './zubale-mark.png';

const LogoIcon = () => (
  <img src={zubaleMark} alt="Zubale" height={28} width={28} />
);

export default LogoIcon;
